import * as React from 'react'
import {Component, ReactElement} from 'react'
import { Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from '@mui/material';
import {Nullable} from '../../../../app/TypeHelpers'
import {LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import {StylesProvider} from '@mui/styles'
import {DisplayBlockDiv} from '../../../../styledComponents/DisplayItem'
import {PrimaryStyledButton} from '../../../../styledComponents/Button'

interface Props {
    open: boolean
    handleClick: () => void
}

export default class NatHasekoIdDescriptionDialogComponent extends Component<Props> {

    constructor(props: Props) {
        super(props)
    }

    render(): Nullable<ReactElement> {
        const {open, handleClick} = this.props

        return (<>
            <StylesProvider injectFirst>
                <Dialog
                    id={'pp-dialog'}
                    open={open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                >
                    <DialogTitle id="alert-dialog-title">
                        <BoldLeftRowFlexContainer>
                            ユーザ登録にあたって
                        </BoldLeftRowFlexContainer>
                    </DialogTitle>
                    <DialogContent>
                        <StyledDialogContentText id="alert-dialog-description">
                            {'素敵ネットでは、長谷工グループの各種サービスをご利用いただくための「長谷工グループ共通のID（長谷工ID）」が必要となります。\n\n' +
                                '長谷工IDをお持ちでない方は、本手続きで素敵ネットのユーザ登録を実施いただくことで長谷工IDが発行されます。'
                            }
                        </StyledDialogContentText>
                    </DialogContent>
                    <StyledDialogActions>
                        <ButtonContainer>
                            <PrimaryStyledButton onClick={handleClick}>
                                手続きに進む
                            </PrimaryStyledButton>
                        </ButtonContainer>
                    </StyledDialogActions>
                </Dialog>
            </StylesProvider>
        </>)
    }
}

const StyledDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    padding: 8px 24px;
  }
`

const StyledDialogContentText = styled(DialogContentText)`
  &.MuiDialogContentText-root {
    font-size: ${FontSize.Body};
    white-space: pre-line;
    color: ${Colors.Body}
  }
`

const BoldLeftRowFlexContainer = styled(LeftRowFlexContainer)`
  font-weight: ${FontWeights.Bold};
  font-size: ${FontSize.Accent};
  color: ${Colors.Body}
`

const ButtonContainer = styled(DisplayBlockDiv)`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`